
import { Component, Vue, Watch } from "vue-property-decorator";
import CatalogoResponse from "@/models/CatalogoResponse";
import AfiliadoService from "../services/AfiliadoService";
import Banco from "@/models/Banco";
import FormaDePago from "@/models/FormaDePago";
import RegistroPresolicitud from "@/models/RegistroPresolicitud";
import { AxiosResponse } from "axios";
import ServiceResponseSolicitud from "@/services/response-models/ServiceResponseSolicitud";
import { Action, Getter } from "vuex-class";
import User from "@/models/User";
import ValidationService from "@/services/ValidationService";
import ValidacionCedulaIt, {
  ValidacionCedulaItResp,
} from "@/models/ValidacionCedulaIt";
import Esigner from "@/models/Esigner";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";
import ServiceResponseEntity from "@/services/response-models/ServiceResponseEntity";
import VeeValidateForm from "@/vee-validate/types/VeeValidateForm";
import CustomFileInput from "@/components/CustomFileInput.vue";
import IngresoTardioService from "@/services/IngresoTardioService";
import {
  ParametrosValidacionRequisitosBeneficio,
  Requisito,
} from "@/models/RequisitoBeneficio";
import FirmanteContratoIngresoTardio from "@/models/FirmanteContratoIngresoTardio";
import ServiceResponseSolicitudes from "@/services/response-models/ServiceResponseSolicitudes";
import Presolicitud from "@/models/Presolicitud";
import ServiceResponseArchivos from "@/services/response-models/ServiceResponseArchivos";
import DocumentoPresolicitud from "@/models/DocumentoPresolicitud";
import ServiceResponseEntities from "@/services/response-models/ServiceResponseEntities";
import { formatFechaAfpSiembra, formatCedula } from "@/utils/HelperFunctions";
import Swal, { SweetAlertResult } from "sweetalert2";
import Inputmask from "inputmask";
import VueFormWizard from "@/vue-form-wizard/types/VueFormWizard";
import PackageResult from "@/models/PackageResult";
import ModalidadRetiroITResponse, {
  ModalidadRetiroIT,
} from "@/models/ModalidadRetiroIT/ModalidadRetiroIT";
import VueFormWizardButton from "@/vue-form-wizard/types/VueFormWizardButton";
import ParametrosObtencionPresolicitud from "@/models/ParametrosObtencionPresolicitud";
import FormaGeneraSolicitudEnum from "@/enums/FormaGeneraSolicitudEnum";
import ValidacionCertificacionTss from "@/models/ValidacionCertificacionTss";
import FileConfig from "../FileConfig";
import TipoRequisitoEnum from "@/enums/TipoRequisitoEnum";
import ServiceResponse from "@/services/response-models/ServiceResponse";
import ConsultaFallecido, {
  ConsultaValidacionBeneficiarioResp,
} from "@/models/ConsultaFallecido";
import { extend } from "vee-validate";
import { detectCedula } from '@/utils/DetectCedula';
import { convertBase64ToFile, convertFileToBase64 } from '@/utils/ConvertBase64ToFile';
import { sanitizeFileName } from '@/utils/SanitizeFileName';
Vue.directive("input-mask", {
  update: function(el: any, binding: any, vnode: any) {
    const mascara: string = vnode.data.attrs.mask;
    const im = new Inputmask(mascara);
    im.mask(el);
  },
});

extend("mask", {
  validate: (value: string, params) => {
    var inputContains_ = value.indexOf("_") > -1;
    return !inputContains_;
  },
  params: [{ name: "mask" }],
  message: "El número de cuenta es inválido.",
});

class FormWizardStep {
  public tabIndex: number;
  public formWizardChildrenIndex: number;
}

@Component({ components: { CustomFileInput } })
export default class RegistroIngresoTardio extends Vue {
  public portalUrl: string = process.env.VUE_APP_PROD_BASE_URL;
  public registroPresolicitud: RegistroPresolicitud = new RegistroPresolicitud();
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public validationService: ValidationService = new ValidationService();
  public ingresoTardioService: IngresoTardioService = new IngresoTardioService();
  public fileConfig: FileConfig;
  //#region Cédula
  public cedulaFrontalServerMessage: string = "";
  public cedulaTraseraServerMessage: string = "";
  public cedulaFrontalFiles: Array<File> = [];
  public cedulaTraseraFiles: Array<File> = [];
  public processedBase64Images: Array<string> = [];
  public inputCedulaFrontalIsValid: boolean = false;
  public inputCedulaTraseraIsValid: boolean = false;
  //#endregion
  //#region Documento
  public documentoServerMessage: string = "";
  public documentoFiles: Array<File> = [];
  //#endregion
  //#region Referencia Documento Bancario
  public referenciaDocumentoBancarioFiles: Array<File> = [];
  public showReferenciaDocumentoBancarioFilesRequiredError: boolean = false;
  public showInvalidReferenciaDocumentoBancarioFilesTypeError: boolean = false;
  public showInvalidReferenciaDocumentoBancarioFilesSizeError: boolean = false;
  public showReferenciaDocumentoBancarioServerValidationMessage: boolean = false;
  public referenciaDocumentoBancarioFilesRequiredMessage: string =
    "La referencia de documento bancario es requerida.";
  public referenciaDocumentoBancarioServerValidationMessage: string = "";
  public inputReferenciaDocumentoBancarioIsValid: boolean = false;

  //#endregion
  //#region Documentos Adicionales
  public documentoAdicionalFiles: Array<Array<File>> = [];
  public showDocumentoAdicionalFilesRequiredError: Array<boolean> = [];
  public showInvalidDocumentoAdicionalFilesTypeError: Array<boolean> = [];
  public showInvalidDocumentoAdicionalFilesSizeError: Array<boolean> = [];
  public documentoAdicionalFilesRequiredMessage: string =
    "El documento adicional es requerido";
  //#endregion
  public triggerInputValidations = false;
  public formWizardButtons: Array<
    Array<VueFormWizardButton<RegistroIngresoTardio>>
  > = [];
  public formWizardSteps: {
    firstStep: FormWizardStep;
    secondStep: FormWizardStep;
    thirdStep: FormWizardStep;
    fourthStep: FormWizardStep;
    fifthStep: FormWizardStep;
  } = {
    firstStep: {
      tabIndex: 0,
      formWizardChildrenIndex: 5,
    },
    secondStep: {
      tabIndex: 1,
      formWizardChildrenIndex: 6,
    },
    thirdStep: {
      tabIndex: 2,
      formWizardChildrenIndex: 7,
    },
    fourthStep: {
      tabIndex: 3,
      formWizardChildrenIndex: 8,
    },
    fifthStep: {
      tabIndex: 4,
      formWizardChildrenIndex: 9,
    },
  };
  public tiposDocumentoByDocumento: {
    tipoDocumentoCedula: string;
    tipoDocumentoDocumento: Array<string>;
    tipoDocumentoReferenciaDocumentoBancario: string;
    tipoDocumentoDocumentosAdicionales: Array<Array<string>>;
  } = {
    tipoDocumentoCedula: null,
    tipoDocumentoDocumento: [],
    tipoDocumentoReferenciaDocumentoBancario: null,
    tipoDocumentoDocumentosAdicionales: [],
  };
  public cedulaIsValid: boolean = false;
  public documentoIsValid: boolean = false;
  public datosCedulaCoincideConBD: boolean = true;
  public resultValidacionCedula: ValidacionCedulaItResp = null;
  //#region Tipo de Documento
  public tiposDocumento: Array<Requisito> = [];
  public tiposDocumentoLoading: boolean = false;
  public tipoDocumento: Requisito = null;
  //#endregion
  //#region Select Vias Notificacion
  public viasNotificacion: Array<CatalogoResponse> = [];
  public viasNotificacionLoading: boolean = false;
  public viaNotificacion: CatalogoResponse = null;
  //#endregion
  //#region Metodo de Pago
  public metodosDePago: Array<FormaDePago> = [];
  public metodosDePagoLoading: boolean = false;
  public metodoDePago: FormaDePago = null;

  public modalidadesRetiroIT: Array<ModalidadRetiroIT> = [];
  public modalidadesRetiroITLoading: boolean = false;
  public modalidadRetiroIT: ModalidadRetiroIT = null;

  //#endregion
  //#region Banco
  public bancos: Array<Banco> = [];
  public bancosLoading: boolean = false;
  public banco: Banco = null;
  //#endregion
  //#region Tipo de Cuenta
  public tiposDeCuenta: Array<CatalogoResponse> = [];
  public tiposDeCuentaLoading: boolean = false;
  public tipoDeCuenta: CatalogoResponse = null;
  //#endregion
  public validacionTssActualizadaDespues24hours = false;
  public numeroCuenta: string = null;
  public montoRetiro: number = null;
  @Getter("user") user: User;
  @Getter("validacionCertificacionTss")
  validacionCertificacionTss: ValidacionCertificacionTss;
  @Action("setUserLoggedAction") setUserLoggedAction;
  @Action("setValidacionCertificacionTssAction")
  setValidacionCertificacionTssAction;
  public loading: boolean = false;
  public numeroSolicitudCreada: number = null;
  public signUrlContrato: string = null;
  public ingresoTardioWizard: VueFormWizard = null;
  public omitirActualizacionDatos: boolean = false;
  public modificaValorViaNotificacion: boolean = false;
  public valorViaNotificacion: string = null;
  //#region Edición
  public currentPresolicitud: Presolicitud = null;
  public documentosCurrentPresolicitud: DocumentoPresolicitud[] = [];
  public documentosAdicionales: DocumentoPresolicitud[] = [];
  public numeroSolicitud: number = null;
  public isEditing: boolean = false;
  public loadingFiles: boolean = false;
  public previousCedulaFrontalFiles: Array<DocumentoPresolicitud> = [];
  public previousCedulaTraseraFiles: Array<DocumentoPresolicitud> = [];
  public previousDocumentoFiles: Array<DocumentoPresolicitud> = [];
  public previousReferenciaDocumentoBancarioFiles: Array<
    DocumentoPresolicitud
  > = [];
  public previousDocumentoAdicionalFiles: Array<DocumentoPresolicitud> = [];
  public removedFiles: Array<DocumentoPresolicitud> = [];
  //#endregion
  private debounceTimeout: number | undefined;

  public callInputValidation() {
    this.triggerInputValidations = !this.triggerInputValidations;
  }
  public created() {
    if (this.user.esAfiInactivo) this.$router.push("/");

    this.fileConfig = new FileConfig(5, [
      "image/jpeg",
      "image/jpg",
      "image/tiff",
      "image/png",
      "application/pdf",
    ]);
    window.addEventListener("beforeunload", this.beforeUnloadHandler);
  }

  public async mounted() {
    await this.getModalidadRetiroIT();
    //this.setFieldValues();
    this.removeParcial();
    this.ingresoTardioWizard = this.$refs.ingresoTardioWizard as VueFormWizard;
    await this.updateUser();
    if (this.$route.query.numeroSolicitud) {
      this.numeroSolicitud = Number(this.$route.query.numeroSolicitud);
      this.isEditing = !!this.numeroSolicitud;
      if (this.isEditing) {
        this.showLoadingAlert(
          "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."
        );
        this.currentPresolicitud = await this.getPresolicitud();
        if (this.currentPresolicitud.solCancelada) {
          this.showLoadingConfirm("Esta solicitud ha sido cancelada.", () => {
            this.$router.push("/home");
            Swal.close();
          });
          return;
        }
        const currentDate: string = (
          await this.afiliadoService.getCurrentDate()
        ).data.currentDate;
        const hourDifference: number =
          Math.abs(
            new Date(currentDate).getTime() -
              new Date(this.currentPresolicitud.fechaSolicitud).getTime()
          ) /
          (60 * 60 * 1000);
        const hourDifferenceGreaterThan24: boolean = hourDifference >= 24;
        if (hourDifferenceGreaterThan24) {
          this.validacionTssActualizadaDespues24hours = true;
          await this.validarTss();
        }
        this.documentosCurrentPresolicitud = await this.getDocumentosPresolicitud();
        //
        //Update UI values from server
        this.datosCedulaCoincideConBD =
          this.currentPresolicitud.cedulaCoincide &&
          this.currentPresolicitud.nombreCoincide &&
          this.currentPresolicitud.fechaNacimientoCoincide;
        this.resultValidacionCedula = new ValidacionCedulaItResp(
          this.currentPresolicitud.cedulaCoincide,
          this.currentPresolicitud.nombreCoincide,
          this.currentPresolicitud.fechaNacimientoCoincide
        );
      }
    } else {
      this.showAsesoriaAlert();
    }

    this.formWizardButtons = [
      [
        {
          text: "Siguiente",
          action: this.verificarCedula,
          className: "ml-auto siembra-orange-button big-button",
          isLoadingButton: true,
          nextAction: (props: any, _this?: RegistroIngresoTardio) => {
            props.nextTab();
            if (
              _this.datosCedulaCoincideConBD &&
              !_this.existPreviousDocumentoFiles
            ) {
              props.nextTab();
              _this.resetSecondStep();
              _this.disableStep(
                _this.formWizardSteps.secondStep.formWizardChildrenIndex
              );
            } else {
              _this.enableStep(
                _this.formWizardSteps.secondStep.formWizardChildrenIndex
              );
            }
          },
          display: () => true,
        },
      ],
      [
        {
          text: "Anterior",
          action: () =>
            new Promise((resolve, reject) => {
              resolve(true);
            }),
          className: "mr-auto siembra-orange-button big-button",
          isLoadingButton: false,
          nextAction: (props: any) => props.prevTab(),
          display: () => true,
        },
        {
          text: "Omitir",
          action: () => {
            this.omitirActualizacionDatos = true;
            return new Promise((resolve, reject) => {
              resolve(this.secondStepIsValid());
            });
          },
          className: "ml-auto siembra-blue-button big-button",
          isLoadingButton: false,
          nextAction: (props: any) => props.nextTab(),
          display: () =>
            !this.existPreviousDocumentoFiles &&
            this.documentosAdicionales.length == 0,
        },
        {
          text: "Validar",
          action: () => {
            return new Promise((resolve, reject) => {
              if (!this.documentosAdicionalesAreValid()) {
                this.disableStep(
                  this.formWizardSteps.thirdStep.formWizardChildrenIndex
                );
                resolve(false);
                return;
              }

              if (
                (this.existPreviousDocumentoFiles &&
                  this.previousDocumentoRequiereCambioDoc &&
                  !this.documentoIsValid) ||
                (!this.existPreviousDocumentoFiles &&
                  this.documentosAdicionales.length == 0 &&
                  !this.documentoIsValid)
              ) {
                this.callInputValidation();
                resolve(false);
                return;
              }
              this.enableStep(
                this.formWizardSteps.thirdStep.formWizardChildrenIndex
              );
              resolve(this.secondStepIsValid());
              return;
            });
          },
          className: "ml-3 siembra-orange-button big-button",
          isLoadingButton: true,
          nextAction: (props: any, _this: RegistroIngresoTardio) => {
            props.nextTab();
            _this.enableStep(
              _this.formWizardSteps.secondStep.formWizardChildrenIndex
            );
          },
          display: () => true,
        },
      ],
      [
        {
          text: "Anterior",
          action: () =>
            new Promise((resolve, reject) => {
              resolve(true);
            }),
          className: "mr-auto mt-4 siembra-blue-button big-button",
          isLoadingButton: false,
          nextAction: (props: any, _this?: RegistroIngresoTardio) => {
            props.prevTab();
            if (
              _this.datosCedulaCoincideConBD ||
              (_this.isEditing && !_this.existPreviousDocumentoFiles)
            ) {
              props.prevTab();
            }
          },
          display: () => true,
        },
        {
          text: "Siguiente",
          action: () => {
            return new Promise((resolve, reject) => {
              (this.$refs.registroIngresoTardioForm as VeeValidateForm)
                .validate()
                .then((formIsValid) => {
                  //Si el form es valido, verificar si amerita validar fileInput de Documento Bancario
                  if (
                    this.fileInputRefDocumentoBancarioEsRequerido &&
                    (!this.existReferenciaDocumentoBancarioFiles ||
                      !this.inputReferenciaDocumentoBancarioIsValid)
                  ) {
                    this.callInputValidation();
                    resolve(false);
                    return;
                  }
                  if (formIsValid) {
                    //Si llegamos hasta aqui, el formulario es valido y el documento bancario tambien
                    this.completarPresolicitud().then((result) => {
                      resolve(result);
                    });
                    return;
                  }
                  resolve(formIsValid);
                });
            });
          },
          className: "ml-auto mt-4 siembra-orange-button big-button",
          isLoadingButton: true,
          nextAction: (props: any, _this: RegistroIngresoTardio) => {
            _this.ingresoTardioWizard.changeTab(
              props.activeTabIndex,
              _this.formWizardSteps.fourthStep.tabIndex
            );
            _this.disableStep(
              _this.formWizardSteps.firstStep.formWizardChildrenIndex
            );
            _this.disableStep(
              _this.formWizardSteps.secondStep.formWizardChildrenIndex
            );
            _this.disableStep(
              _this.formWizardSteps.thirdStep.formWizardChildrenIndex
            );
            if (_this.generaSolicitudAutomatica) {
              props.nextTab();
              _this.disableStep(
                _this.formWizardSteps.fourthStep.formWizardChildrenIndex
              );
            }
          },
          display: () => true,
        },
      ],
      [
        {
          text: "Ir a mis solicitudes",
          action: this.navigateToSolicitudes,
          className: "ml-auto siembra-orange-button big-button",
          isLoadingButton: false,
          display: () => true,
        },
      ],
      [
        {
          text: "Firmar",
          action: this.firmarContratoIngresoTardio,
          className: "ml-auto siembra-orange-button big-button",
          isLoadingButton: true,
          nextAction: (props: any, _this: RegistroIngresoTardio) => {
            window.removeEventListener(
              "beforeunload",
              this.beforeUnloadHandler
            );
            if (_this.signUrlContrato) {
              if (window.parent) {
                window.parent.location.href = _this.signUrlContrato;
              } else {
                window.location.href = _this.signUrlContrato;
              }
            }
          },
          display: () => true,
        },
      ],
    ];
    // if (this.currentPresolicitud) {
    //     if (this.currentPresolicitud.permiteFirma) {
    //         //this.ignoreFormValidation = true;
    //         this.setFieldValues();
    //         this.moveToFifthStepAndDisableTheRest();
    //         Swal.close();
    //         return;
    //     }
    // }

    await this.getTiposDocumento();
    await this.getViasNotificacion();
    await this.getMetodosDePago();
    await this.getBancos();
    await this.getTiposDeCuenta();
    await this.getTiposDocumentoByStep();
    if (
      this.documentosCurrentPresolicitud &&
      this.documentosCurrentPresolicitud.length > 0
    ) {
      this.setPreviousFiles();
      //
      this.documentosAdicionales.forEach(
        (documentoAdicional: DocumentoPresolicitud) => {
          this.showDocumentoAdicionalFilesRequiredError.push(false);
          this.showInvalidDocumentoAdicionalFilesTypeError.push(false);
        }
      );
    }

    if (this.currentPresolicitud) {
      this.setFieldValues();

      if (this.currentPresolicitud.permiteFirma) {
        this.setFieldValues();
        this.moveToFifthStepAndDisableTheRest();
        Swal.close();
        return;
      }

      if (
        !this.existPreviousDocumentoFiles ||
        this.previousCedulaFrontalRequiereCambioDoc ||
        this.previousCedulaTraseraRequiereCambioDoc
      ) {
        this.disableStep(
          this.formWizardSteps.secondStep.formWizardChildrenIndex
        );
      }
      let currentStep: number = this.formWizardSteps.firstStep.tabIndex;
      //Esto lo comente porque el setCurrentStepBasedOnDocumentsThatRequireToBeChanged se encarga de decidir que step se muestra
      // if (!this.currentPresolicitud.esModificable) {
      //     if (!this.datosCedulaCoincideConBD) {
      //         // // this.ingresoTardioWizard.changeTab(
      //         // //     currentStep,
      //         // //     this.formWizardSteps.secondStep.tabIndex
      //         // // );
      //         currentStep = this.formWizardSteps.secondStep.tabIndex;
      //     } else {
      //         this.ingresoTardioWizard.changeTab(
      //             currentStep,
      //             this.formWizardSteps.thirdStep.tabIndex
      //         );
      //         currentStep = this.formWizardSteps.thirdStep.tabIndex;
      //     }
      // }

      this.setCurrentStepBasedOnDocumentsThatRequireToBeChanged(currentStep);

      //Si la cedula frontal o trasera require lgun cambio doc, quitar ambas cedulas
      // if (this.previousCedulaFrontalRequiereCambioDoc
      //     || this.previousCedulaTraseraRequiereCambioDoc) {
      //         if (this.previousCedulaFrontalFiles[0])
      //             this.removeCedulaFrontalFile(this.previousCedulaFrontalFiles[0]);
      //         if (this.previousCedulaTraseraFiles[0])
      //             this.removeCedulaTraseraFile(this.previousCedulaTraseraFiles[0]);
      // }
      Swal.close();
    }
  }

  get fileInputRefDocumentoBancarioEsRequerido() {
    return (
      this.siEstaCreandoYEsTransferencia ||
      this.siIsEditYEsTransferenciaYDocRequiereCambioYNoTieneComprobante
    );
  }

  get siEstaCreandoYEsTransferencia() {
    return !this.isEditing && this.metodoDePagoIsTransferenciaBancaria;
  }

  get siIsEditYEsTransferenciaYDocRequiereCambioYNoTieneComprobante() {
    return (
      this.isEditing &&
      this.metodoDePagoIsTransferenciaBancaria &&
      this.previousReferenciaDocumentoBancarioRequiereCambioDoc &&
      !this.existReferenciaDocumentoBancarioFiles
    );
  }
  public beforeUnloadHandler(e) {
    e.preventDefault();
    // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    // Chrome requires returnValue to be set
    e.returnValue = "";
  }
  public removeFilesThatRequireChanges() {
    let cedulaFrontalThatRequireChange = this.previousCedulaFrontalFiles.filter(
      (x) => x.requiereCambioDoc
    )[0];
    let cedulaTraseraThatRequireChange = this.previousCedulaTraseraFiles.filter(
      (x) => x.requiereCambioDoc
    )[0];
    if (cedulaFrontalThatRequireChange || cedulaTraseraThatRequireChange) {
      this.removeCedulaFrontalFile(this.previousCedulaFrontalFiles[0]);
      this.removeCedulaTraseraFile(this.previousCedulaTraseraFiles[0]);
    }
    //
    let previousDocumentoFilesThatRequireChange = this.previousDocumentoFiles.filter(
      (x) => x.requiereCambioDoc
    );
    previousDocumentoFilesThatRequireChange.forEach((doc) => {
      this.removeDocumentoFile(doc);
    });
    // let documentoAdicionalFilesThatRequireChange = this.documentosAdicionales
    //     .filter((x) => x.requiereCambioDoc);
    // documentoAdicionalFilesThatRequireChange
    // .forEach((doc) => {
    //     var index = this.documentosAdicionales.indexOf(doc);
    //     this.documentosAdicionales.splice(index,1);
    //     this.removedFiles.push(doc);
    // });

    //
    let previousReferenciaDocumentoBancarioFilesThatRequireChange = this.previousReferenciaDocumentoBancarioFiles.filter(
      (x) => x.requiereCambioDoc
    );
    previousReferenciaDocumentoBancarioFilesThatRequireChange.forEach((doc) => {
      this.removeReferenciaDocumentoBancarioFile(doc);
    });
    //
    let previousDocumentoAdicionalFilesThatRequireChange = this.previousDocumentoAdicionalFiles.filter(
      (x) => x.requiereCambioDoc
    );
    previousDocumentoAdicionalFilesThatRequireChange.forEach((doc) => {
      this.removeDocumentoAdicionalFile(doc);
    });
  }

  public async updateUser(): Promise<void> {
    return new Promise((resolve, reject) => {
      const consultaFallecido = new ConsultaFallecido();
      consultaFallecido.cedulaBeneficiario = this.user.cedula;
      this.afiliadoService
        .consultarBeneficiario(consultaFallecido)
        .then(
          (
            response: AxiosResponse<
              ServiceResponseEntity<ConsultaValidacionBeneficiarioResp>
            >
          ) => {
            const consultaValidacionBeneficiarioResp = response.data.entity;
            this.user.correoElectronico1 =
              consultaValidacionBeneficiarioResp.email1;
            this.user.correoElectronico2 =
              consultaValidacionBeneficiarioResp.email2;
            this.user.celular = consultaValidacionBeneficiarioResp.celular;
            this.setUserLoggedAction(this.user);
            resolve();
          }
        )
        .catch(() => {
          reject();
        });
    });
  }

  public async validarTss(): Promise<void> {
    var result = this.validationService
      .validateIngresoTardio("")
      .then(
        async (
          response: AxiosResponse<
            ServiceResponseEntity<ValidacionCertificacionTss>
          >
        ) => {
          if (response.data.entity.aplicaTramite) {
            this.setValidacionCertificacionTssAction(response.data.entity);
          } else {
            await this.invalidarSolicitud();
          }
        }
      )
      .catch((error) => {
        this.showErrorAlert(
          "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
          true
        );
      });
    return result;
  }

  public async validarRequisitosYTss(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const parametrosValidacionRequisitosBeneficio = new ParametrosValidacionRequisitosBeneficio(
        null,
        this.user.codCuenta,
        TipoRequisitoEnum.Validacion,
        TipoBeneficioEnum.IngresoTardio
      );
      const requisitosBeneficio = (
        await this.validationService.validarRequisitosBeneficios(
          parametrosValidacionRequisitosBeneficio
        )
      ).data.entity;
      // TODO: REMOVER
      // requisitosBeneficio.requisitos.forEach((x) => {
      //     x.cumpleRequisito = true;
      // });
      if (
        requisitosBeneficio.aplicaTramite &&
        requisitosBeneficio.requisitos.every((x) => x.cumpleRequisito)
      ) {
        this.validarTss()
          .then((result) => {
            resolve();
          })
          .catch(() => {
            resolve();
          });
      } else {
        await this.invalidarSolicitud();
        resolve();
      }
    });
  }

  @Watch("tipoDocumento")
  public onTipoDocumentoChangeInStep2(
    newValue: string,
    oldValue: string
  ): void {
    //Cuando el tipo documentoCambie si estamos en ediion hay que resetear el fileInput
    //Esto lo hacemos solo cuando esta editando, porque cuando esta creando si cambia de tipo
    //Documento no hay que resetear el fileInput
    if (this.isEditing && oldValue != null) {
      //Se evalua que all value no sea nulo para que en el first load del edit no modifique esto
      this.resetSecondStep(false);
      this.previousDocumentoFiles.splice(0, this.previousDocumentoFiles.length);
    }
  }
  @Watch("banco")
  public onBancoSelected(newValue: Banco, oldValue: Banco): void {
    if (!!oldValue) {
      const numeroCuentaInput: HTMLInputElement = this.$refs
        .numeroCuenta as HTMLInputElement;
      if (numeroCuentaInput) {
        numeroCuentaInput.value = "";
      }
      this.numeroCuenta = "";
    }
  }

  //El limpiar esta referencia se movio para el boton de registrar
  // @Watch("metodoDePago")
  // public onMetodoDePagoSelected(
  //     newValue: FormaDePago,
  //     oldValue: FormaDePago
  // ): void {
  //     // if (!!oldValue) {
  //     //     this.banco = null;
  //     //     this.tipoDeCuenta = null;
  //     //     this.numeroCuenta = null;
  //     //     this.referenciaDocumentoBancarioFiles = [];
  //     // }
  // }

  public clearUnusedFields() {
    if (!this.metodoDePagoIsTransferenciaBancaria) {
      this.banco = null;
      this.tipoDeCuenta = null;
      this.numeroCuenta = null;
      this.referenciaDocumentoBancarioFiles = [];
    }
  }

  @Watch("viaNotificacion")
  public onViaNotificacionSelected(
    newValue: CatalogoResponse,
    oldValue: CatalogoResponse
  ): void {
    if (!!oldValue) {
      this.modificaValorViaNotificacion = false;
      this.valorViaNotificacion = null;
    }
  }
  @Watch("montoRetiro")
  private onMontoRetiroChanged(): void {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    if(this.currentPresolicitud == null && this.currentPresolicitud.monRetiro == null){
      this.metodoDePago = null;
    }
    this.debounceTimeout = window.setTimeout(() => {
      this.getMetodosDePago();
    }, 1000); 
  }
  public disableStep(step: number): void {
    // (this.ingresoTardioWizard.$children.filter(
    //   (x) => x.$el.localName !== "button"
    // )[step].$el as HTMLElement).style.pointerEvents = "none";
  }

  public enableStep(step: number): void {
    (this.ingresoTardioWizard.$children.filter(
      (x) => x.$el.localName !== "button"
    )[step].$el as HTMLElement).style.pointerEvents = "auto";
  }

  public resetSecondStep(cleanTipoDocumentoSelect: boolean = true): void {
    if (cleanTipoDocumentoSelect) this.tipoDocumento = null;
    this.documentoFiles = [];
    // if (
    //     this.previousDocumentoFiles &&
    //     this.previousDocumentoFiles.length > 0
    // ) {
    //     this.removedFiles.push(...this.previousDocumentoFiles);
    // }
  }

  public setPreviousFiles(): void {
    this.previousCedulaFrontalFiles = [
      this.documentosCurrentPresolicitud.filter(
        (x) =>
          x.tipoDocumento === this.tiposDocumentoByDocumento.tipoDocumentoCedula
      )[0],
    ];
    this.previousCedulaTraseraFiles = [
      this.documentosCurrentPresolicitud.filter(
        (x) =>
          x.tipoDocumento === this.tiposDocumentoByDocumento.tipoDocumentoCedula
      )[1],
    ];
    this.previousDocumentoFiles = [
      ...this.documentosCurrentPresolicitud.filter(
        (x) =>
          this.tiposDocumentoByDocumento.tipoDocumentoDocumento.includes(
            x.tipoDocumento
          ) &&
          !!x.ruta &&
          !x.esAdicional
      ),
    ];
    this.previousReferenciaDocumentoBancarioFiles = [
      ...this.documentosCurrentPresolicitud.filter(
        (x) =>
          x.tipoDocumento ===
          this.tiposDocumentoByDocumento
            .tipoDocumentoReferenciaDocumentoBancario
      ),
    ];
    this.previousDocumentoAdicionalFiles = [
      ...this.documentosCurrentPresolicitud.filter((x) => {
        return x.esAdicional;
      }),
    ];
    if (
      this.previousDocumentoAdicionalFiles &&
      this.previousDocumentoAdicionalFiles.length > 0
    ) {
      this.documentosAdicionales.push(
        ...this.previousDocumentoAdicionalFiles.filter(
          (x) => x.requiereCambioDoc
        )
      );
    }
  }

  public async getTiposDocumentoByStep(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      let tipoDocumentosStep1: Requisito[] = [];
      await this.ingresoTardioService
        .documentosRequeridos(
          String(this.formWizardSteps.firstStep.tabIndex + 1)
        )
        .then(
          (response: AxiosResponse<ServiceResponseEntities<Requisito[]>>) => {
            tipoDocumentosStep1 = response.data.entities;
          }
        );
      let tipoDocumentosStep3: Requisito[] = [];
      await this.ingresoTardioService
        .documentosRequeridos(
          String(this.formWizardSteps.thirdStep.tabIndex + 1)
        )
        .then(
          (response: AxiosResponse<ServiceResponseEntities<Requisito[]>>) => {
            tipoDocumentosStep3 = response.data.entities;
          }
        );
      const tipoDocumentoCedula: string = tipoDocumentosStep1[0].codRequisito.toString();
      const tipoDocumentoDocumento: Array<string> = this.tiposDocumento.map(
        (x) => x.codRequisito.toString()
      );
      const tipoDocumentoReferenciaDocumentoBancario: string = tipoDocumentosStep3[0].codRequisito.toString();
      this.tiposDocumentoByDocumento = {
        tipoDocumentoCedula,
        tipoDocumentoDocumento,
        tipoDocumentoReferenciaDocumentoBancario,
        tipoDocumentoDocumentosAdicionales: [],
      };
      resolve();
    });
  }

  public setDatosTss(presolicitud: Presolicitud): Presolicitud {
    const presolicitudClone = {
      ...presolicitud,
    };
    //
    if (this.currentPresolicitud) {
      //Si se esta editando y se hizo una validacion de certificacionTss despues de 24 horas
      //usar los nuevos valores, de lo contrario usar los valores originales
      if (this.validacionTssActualizadaDespues24hours) {
        presolicitudClone.numeroCertTSS = this.validacionCertificacionTss.numeroCertificacion;
        presolicitudClone.fechaCertTSS = this.validacionCertificacionTss.fecha;
        presolicitudClone.estadoCertTSS = this.validacionCertificacionTss.estado;
      } else {
        presolicitudClone.numeroCertTSS = this.currentPresolicitud.numeroCertTSS;
        presolicitudClone.fechaCertTSS = this.currentPresolicitud.fechaCertTSS;
        presolicitudClone.estadoCertTSS = this.currentPresolicitud.estadoCertTSS;
      }
    } else {
      if (this.validacionCertificacionTss) {
        presolicitudClone.numeroCertTSS = this.validacionCertificacionTss.numeroCertificacion;
        presolicitudClone.fechaCertTSS = this.validacionCertificacionTss.fecha;
        presolicitudClone.estadoCertTSS = this.validacionCertificacionTss.estado;
      }
    }
    return presolicitudClone;
  }

  public setFieldValues(): void {
    if (this.previousDocumentoFiles && this.previousDocumentoFiles.length > 0) {
      this.tipoDocumento = this.tiposDocumento.find(
        (x) =>
          x.codRequisito ===
          Number(this.previousDocumentoFiles[0].tipoDocumento)
      );
    }
    this.metodoDePago = this.metodosDePago.find(
      (x) => x.formaPago === this.currentPresolicitud.formaPago
     
    );
    this.banco = this.bancos.find(
      (x) => x.codigoBanco === String(this.currentPresolicitud.idBanco)
    );
    this.tipoDeCuenta = this.tiposDeCuenta.find(
      (x) => x.value === this.currentPresolicitud.tipoCuenta
    );
    this.numeroCuenta = this.currentPresolicitud.numeroCuenta;
    this.viaNotificacion = this.viasNotificacion.find(
      (x) => x.value === this.currentPresolicitud.viaNotificacion
    );

    this.modalidadRetiroIT = this.modalidadesRetiroIT.find(
      (x) => x.codigo === this.currentPresolicitud.tipRetiro
    );
  }

  public moveToFifthStepAndDisableTheRest(): void {
    this.ingresoTardioWizard.changeTab(
      this.formWizardSteps.firstStep.tabIndex,
      this.formWizardSteps.fifthStep.tabIndex
    );
    this.disableStep(this.formWizardSteps.firstStep.formWizardChildrenIndex);
    this.disableStep(this.formWizardSteps.secondStep.formWizardChildrenIndex);
    this.disableStep(this.formWizardSteps.thirdStep.formWizardChildrenIndex);
    this.disableStep(this.formWizardSteps.fourthStep.formWizardChildrenIndex);
  }

  public setCurrentStepBasedOnDocumentsThatRequireToBeChanged(
    currentStep: number
  ): void {
    if (
      this.previousCedulaFrontalRequiereCambioDoc ||
      this.previousCedulaTraseraRequiereCambioDoc
    ) {
      this.ingresoTardioWizard.changeTab(
        currentStep,
        this.formWizardSteps.firstStep.tabIndex
      );
      currentStep = this.formWizardSteps.firstStep.tabIndex;
    } else if (
      this.previousDocumentoRequiereCambioDoc ||
      this.documentosAdicionales.length > 0
    ) {
      this.ingresoTardioWizard.changeTab(
        currentStep,
        this.formWizardSteps.secondStep.tabIndex
      );
      currentStep = this.formWizardSteps.secondStep.tabIndex;
    } else if (this.previousReferenciaDocumentoBancarioRequiereCambioDoc) {
      this.ingresoTardioWizard.changeTab(
        currentStep,
        this.formWizardSteps.thirdStep.tabIndex
      );
      currentStep = this.formWizardSteps.thirdStep.tabIndex;
    }
  }

  public async getPresolicitud(): Promise<Presolicitud> {
    return new Promise((resolve, reject) => {
      this.afiliadoService
        .getPresolicitud(
          new ParametrosObtencionPresolicitud(
            this.numeroSolicitud,
            this.user.cedula,
            null,
            null
          )
        )
        .then((response: AxiosResponse<ServiceResponseSolicitudes>) => {
          if (
            response.data.solicitudes &&
            response.data.solicitudes.length > 0
          ) {
            const currentPresolicitud: Presolicitud = response.data.solicitudes.find(
              (x) => x.numeroSolicitud == this.numeroSolicitud
            );
            resolve(currentPresolicitud || null);
          } else {
            this.$router.push("/solicitudes-beneficiario");
            resolve(null);
          }
        })
        .catch(() => {
          reject();
        });
    });
  }

  public async getDocumentosPresolicitud(): Promise<DocumentoPresolicitud[]> {
    this.loadingFiles = true;
    return new Promise((resolve, reject) => {
      this.afiliadoService
        .getDocumentosPresolicitud(this.numeroSolicitud)
        .then((response: AxiosResponse<ServiceResponseArchivos>) => {
          this.loadingFiles = false;
          resolve(response.data.archivos);
        })
        .catch(() => {
          this.loadingFiles = false;
          reject();
        });
    });
  }

  public showLoadingAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });
  }

  public showLoadingConfirm(message: string, onClose: () => void = () => {}) {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      allowOutsideClick: false,
      showConfirmButton: true,
      confirmButtonText: "Ok",
      onClose,
    });
  }

  public showErrorAlert(
    message: string,
    allowOutsideClick: boolean = true
  ): void {
    Swal.fire({
      text: message,
      icon: "error",
      showConfirmButton: allowOutsideClick,
      confirmButtonText: "Ok",
      allowOutsideClick,
    });
  }

  public showInfoAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
    });
  }

  get inputNumeroCuentaRules() {
    if (!this.banco) {
      return "";
    }

    if (!this.banco.validaMascara) {
      var mask = "";

      for (let i = 0; i < this.banco.lenMinimaCuenta; i++) {
        mask = mask + "9";
      }
      for (
        let i = 0;
        i < this.banco.lenMaximaCuenta - this.banco.lenMinimaCuenta;
        i++
      ) {
        mask = mask + "[9]";
      }
      this.banco.mascaraCuenta = mask;

      var mask = this.banco ? String(this.banco.mascaraCuenta) : "";
      return (
        "required|mymin-validation:" +
        String(this.banco.lenMinimaCuenta) +
        "|mymax-validation:" +
        String(this.banco.lenMaximaCuenta) +
        "|mask:" +
        String(mask)
      );
    } else {
      var mask = this.banco ? String(this.banco.mascaraCuenta) : "";
      return "required|mask:" + String(this.banco.mascaraCuenta);
    }
  }
  get isParcial() {
    var result = this.modalidadRetiroIT?.codigo === "P";
    if (!result) {
      this.montoRetiro = Number(this.user.saldoCCI.toFixed(2));
    }
    return result;
  }
  get inputMontoRetiroRules() {
    return (
      "required|minimo-number-validation:" +
      String(this.getMinimoRetiro) +
      "|maximo-number-validation:" +
      String(this.getMaximoRetiro.toFixed(2))
    );
  }
  get getMinimoRetiro() {
    if (this.user.saldoCCI > this.modalidadRetiroIT?.montoMinimo) {
      return this.modalidadRetiroIT.montoMinimo;
    } else {
      return this.user.saldoCCI;
    }
  }
  get getMaximoRetiro() {
    if (this.modalidadRetiroIT?.codigo == "P") {
      return this.user.saldoCCI - 1;
    } else {
      return this.user.saldoCCI;
    }
  }

  get currentPresolicitudEsModificable(): boolean {
    return this.currentPresolicitud && this.currentPresolicitud.esModificable;
  }

  get inputsCedulaAreValid(): boolean {
    return this.inputCedulaFrontalIsValid && this.inputCedulaTraseraIsValid;
  }

  get cedulaAfiliado(): string {
    return formatCedula(this.user.cedula);
  }

  get fechaNacimientoAfiliado(): string {
    return formatFechaAfpSiembra(this.user.fechaNacimientoDate);
  }

  get cedulaFiles(): File[] {
    return this.cedulaFrontalFiles.concat(this.cedulaTraseraFiles);
  }

  get previousCedulaFrontalRequiereCambioDoc(): boolean {
    return (
      this.previousCedulaFrontalFiles &&
      this.previousCedulaFrontalFiles.filter((x) => x.requiereCambioDoc)
        .length > 0
    );
  }

  get previousCedulaTraseraRequiereCambioDoc(): boolean {
    return (
      this.previousCedulaTraseraFiles &&
      this.previousCedulaTraseraFiles.filter((x) => x.requiereCambioDoc)
        .length > 0
    );
  }

  get previousDocumentoRequiereCambioDoc(): boolean {
    return (
      this.previousDocumentoFiles &&
      this.previousDocumentoFiles.filter((x) => x.requiereCambioDoc).length > 0
    );
  }

  get previousReferenciaDocumentoBancarioRequiereCambioDoc(): boolean {
    return (
      this.previousReferenciaDocumentoBancarioFiles &&
      this.previousReferenciaDocumentoBancarioFiles.filter(
        (x) => x.requiereCambioDoc
      ).length > 0
    );
  }

  get showCedulaFrontalInput(): boolean {
    return (
      !this.isEditing ||
      ((!this.existPreviousCedulaFrontalFiles ||
        this.previousCedulaFrontalRequiereCambioDoc ||
        this.previousCedulaTraseraRequiereCambioDoc) &&
        !this.loadingFiles)
    );
  }

  get showCedulaTraseraInput(): boolean {
    return (
      !this.isEditing ||
      ((!this.existPreviousCedulaTraseraFiles ||
        this.previousCedulaTraseraRequiereCambioDoc ||
        this.previousCedulaFrontalRequiereCambioDoc) &&
        !this.loadingFiles)
    );
  }

  public documentosAdicionalesAreValid(): boolean {
    return (
      !this.documentosAdicionales ||
      this.documentosAdicionales.length === 0 ||
      (this.documentosAdicionales &&
        this.documentosAdicionales.length > 0 &&
        this.documentosAdicionales.every(
          (documentoAdicional: Presolicitud, index: number) => {
            var documentoAdicionalTieneArchivo =
              !!this.documentoAdicionalFiles[index] &&
              this.documentoAdicionalFiles[index].length > 0;
            //
            if (!documentoAdicionalTieneArchivo) {
              this.showDocumentoAdicionalFilesRequiredError[index] = true;
              this.$forceUpdate();
              return false;
            }

            if (this.showInvalidDocumentoAdicionalFilesTypeError[index])
              return !this.showInvalidDocumentoAdicionalFilesTypeError[index];

            if (this.showInvalidDocumentoAdicionalFilesSizeError[index])
              return !this.showInvalidDocumentoAdicionalFilesSizeError[index];

            return true;
          }
        ))
    );
  }
  public onInputNumber(event) {
  event.target.value = event.target.value
    .replace(/[^0-9.]/g, '') 
    .replace(/(\..*)\./g, '$1') 
    .replace(/(\.\d{2})\d+/g, '$1');

  this.montoRetiro = event.target.value;
}

  public fileRemoveConfirmAlert(
    fileName: string
  ): Promise<SweetAlertResult<boolean>> {
    return Swal.fire({
      text: "¿Deseas eliminar el archivo " + fileName + " ?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ED8B2F",
      cancelButtonColor: "#0F6CBC",
      confirmButtonText: "OK",
      reverseButtons: true,
    });
  }

  public onRemoveCedulaFrontalFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeCedulaFrontalFile(archivoPresolicitud);
          this.removeCedulaTraseraFile(this.previousCedulaTraseraFiles[0]);
        }
      }
    );
  }

  public removeCedulaFrontalFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousCedulaFrontalFiles.indexOf(
      archivoPresolicitud
    );
    this.previousCedulaFrontalFiles.splice(index, 1);
    this.removedFiles.push(archivoPresolicitud);
  }

  public onRemoveCedulaTraseraFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeCedulaTraseraFile(archivoPresolicitud);
          this.removeCedulaFrontalFile(this.previousCedulaFrontalFiles[0]);
        }
      }
    );
  }

  public removeCedulaTraseraFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousCedulaTraseraFiles.indexOf(
      archivoPresolicitud
    );
    if (index > -1) {
      this.previousCedulaTraseraFiles.splice(index, 1);
      this.removedFiles.push(archivoPresolicitud);
    }
  }

  public removeDocumentoFile(
    documentoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousDocumentoFiles.indexOf(
      documentoPresolicitud
    );
    this.previousDocumentoFiles.splice(index, 1);
    this.removedFiles.push(documentoPresolicitud);
  }

  public removeReferenciaDocumentoBancarioFile(
    documentoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousReferenciaDocumentoBancarioFiles.indexOf(
      documentoPresolicitud
    );
    this.previousReferenciaDocumentoBancarioFiles.splice(index, 1);
    this.removedFiles.push(documentoPresolicitud);
  }

  public removeDocumentoAdicionalFile(
    documentoPresolicitud: DocumentoPresolicitud
  ): void {
    const index: number = this.previousDocumentoAdicionalFiles.indexOf(
      documentoPresolicitud
    );
    this.previousDocumentoAdicionalFiles.splice(index, 1);
    this.removedFiles.push(documentoPresolicitud);
  }

  public onRemoveDocumentoFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeDocumentoFile(archivoPresolicitud);
        }
      }
    );
  }

  public onRemoveReferenciaDocumentoBancarioFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeReferenciaDocumentoBancarioFile(archivoPresolicitud);
        }
      }
    );
  }

  public onRemoveDocumentoAdicionalFile(
    archivoPresolicitud: DocumentoPresolicitud
  ): void {
    const fileName: string = this.getFileName(archivoPresolicitud.ruta);
    this.fileRemoveConfirmAlert(fileName).then(
      (result: SweetAlertResult<boolean>) => {
        if (result.value) {
          this.removeDocumentoAdicionalFile(archivoPresolicitud);
          //this.documentosAdicionales.push(archivoPresolicitud);
        }
      }
    );
  }

  public getFileName(fileUrl: string): string {
    if (fileUrl.includes("/")) {
      const fileName = fileUrl.split("/");
      return fileName[fileName.length - 1];
    } else {
      return fileUrl;
    }
  }

public async onAddOrRemoveCedulaFrontalFile(files: Array<File>): Promise<void> {
    this.disableStep(this.formWizardSteps.secondStep.formWizardChildrenIndex);
    //this.cedulaFrontalFiles = files;
    this.cedulaIsValid = false;
    this.cedulaFrontalServerMessage = "";
    this.processedBase64Images = [];
for (let file of files) {
  let base64Image: string;
  if (file.type === 'application/pdf') {
          try {
            const base64Pdf = await convertFileToBase64(file);
            const response = await this.afiliadoService.convertPdfToImage(base64Pdf);
            if (response.data.images && response.data.images.length > 0) {
              const images = response.data.images[0];
              const files = new File([Uint8Array.from(atob(images), (m) => m.codePointAt(0))],'myfilename.jpeg',{ type: "image/jpeg" });
              base64Image = await detectCedula(new File([files], "converted_pdf.png", { type: "image/png" }), "front");
            } else {
              console.error("No se encontraron imágenes en el PDF.");
            }
          } catch (error) {
            console.error("Error al convertir PDF a imagen:", error);
          }
        }
        else{
          base64Image= await detectCedula(file, "front");
        }
      this.processedBase64Images.push(base64Image);
    }

    this.cedulaFrontalFiles = convertBase64ToFile(
      this.processedBase64Images,
      "cedula_frontal_solicitud"
    );
  }

  public cedulaFrontalValidationChanged(isValid: boolean): void {
    this.inputCedulaFrontalIsValid = isValid;
  }


 public async onAddOrRemoveCedulaTraseraFile(files: Array<File>): Promise<void> {
    this.disableStep(this.formWizardSteps.secondStep.formWizardChildrenIndex);
    //this.cedulaTraseraFiles = files;
    this.cedulaIsValid = false;
    this.cedulaTraseraServerMessage = "";
    this.processedBase64Images = [];
    for (let file of files) {
      let base64Image: string;
  if (file.type === 'application/pdf') {
          try {
            const base64Pdf = await convertFileToBase64(file);
            const response = await this.afiliadoService.convertPdfToImage(base64Pdf);
            if (response.data.images && response.data.images.length > 0) {
              const images = response.data.images[0];
              const files = new File([Uint8Array.from(atob(images), (m) => m.codePointAt(0))],'archivo.jpeg',{ type: "image/jpeg" });
              base64Image = await detectCedula(new File([files], "converted_pdf.png", { type: "image/png" }), "back");
              console.log("base64Image",base64Image)
            } else {
              console.error("No se encontraron imágenes en el PDF.");
            }
          } catch (error) {
            console.error("Error al convertir PDF a imagen:", error);
          }
        } else{
          base64Image = await detectCedula(file, "back");
        }
      this.processedBase64Images.push(base64Image);
    }

    this.cedulaTraseraFiles = convertBase64ToFile(
      this.processedBase64Images,
      "cedula_trasera_solicitud"
    );
  }

  public cedulaTraseraValidationChanged(isValid: boolean): void {
    this.inputCedulaTraseraIsValid = isValid;
  }

  public onAddOrRemoveDocumentoFile(files: Array<File>): void {
    const sanitizedFiles = files.map((file) => {
        const cleanName = sanitizeFileName(file.name);
        return new File([file], cleanName, { type: file.type });
    });
        //this.documentoFiles = files;
    this.documentoFiles = sanitizedFiles;
    this.documentoIsValid = false;
    this.documentoServerMessage = "";
  }

  public documentoValidationChanged(isValid: boolean): void {
    this.documentoIsValid = isValid;
  }

  public referenciaDocumentoBancarioValidationChanged(isValid: boolean): void {
    this.inputReferenciaDocumentoBancarioIsValid = isValid;
  }

  public onAddOrRemoveReferenciaDocumentoBancarioFile(
    files: Array<File>
  ): void {
    const sanitizedFiles = files.map((file) => {
            const cleanName = sanitizeFileName(file.name);
            return new File([file], cleanName, { type: file.type });
        });
        this.referenciaDocumentoBancarioFiles = sanitizedFiles;
        //this.referenciaDocumentoBancarioFiles = files;
    this.inputReferenciaDocumentoBancarioIsValid = false;
    this.referenciaDocumentoBancarioServerValidationMessage = "";
  }

  public onAddOrRemoveDocumentoAdicionalFile(
    index: number,
    tipoDocumento: string
  ): void {
    let pond: any = this.$refs["documentoAdicional" + index][0];
    this.documentoAdicionalFiles[index] = pond.getFiles().map((x) => x.file);
    const tiposDocumento: Array<string> = this.documentoAdicionalFiles[
      index
    ].map(() => {
      return tipoDocumento;
    });
    this.tiposDocumentoByDocumento.tipoDocumentoDocumentosAdicionales[
      index
    ] = tiposDocumento;
    //
    this.showDocumentoAdicionalFilesRequiredError[index] =
      this.documentoAdicionalFiles[index].length === 0;
    if (this.showDocumentoAdicionalFilesRequiredError[index]) {
      this.disableStep(this.formWizardSteps.thirdStep.formWizardChildrenIndex);
    }

    const anyFileTypeInvalid: boolean = this.documentoAdicionalFiles[
      index
    ].some((x) => !this.fileConfig.allowedFileTypes.includes(x.type));
     const anyFileExtensionInvalid: boolean = this.documentoAdicionalFiles[
      index
    ].some(
      (x) =>   this.fileConfig.notAllowExtensions.some(substring=>x.name.includes(substring))
    );

    if(anyFileExtensionInvalid || anyFileTypeInvalid){
          this.showInvalidDocumentoAdicionalFilesTypeError[
      index
    ] = true;
      }else{
          this.showInvalidDocumentoAdicionalFilesTypeError[
      index
    ] = false;
      }

    const anyFileSizeInvalid: boolean = this.documentoAdicionalFiles[
      index
    ].some((x) => x.size / 1000000 > this.fileConfig.fileSizeMbLimit);
    this.showInvalidDocumentoAdicionalFilesSizeError[
      index
    ] = anyFileSizeInvalid;
    this.$forceUpdate();
  }

  public async getTiposDocumento() {
    this.tiposDocumentoLoading = true;
    const response = await this.ingresoTardioService.documentosRequeridos(
      String(this.formWizardSteps.secondStep.tabIndex + 1)
    );
    if (response.data.entities) {
      this.tiposDocumento = response.data.entities;
    } else {
      this.tiposDocumento = [];
    }
    this.tiposDocumentoLoading = false;
  }

  public async getViasNotificacion(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.viasNotificacionLoading = true;
    const response = await this.afiliadoService.viasNotificacion(term);
    if (response.data.entity) {
      this.viasNotificacion = response.data.entity;
    } else {
      this.viasNotificacion = [];
    }
    this.viasNotificacionLoading = false;
  }

  public async getBancos(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.bancosLoading = true;
    const response = await this.afiliadoService.bancos(term);
    if (response.data.entities) {
      this.bancos = response.data.entities;
    } else {
      this.bancos = [];
    }
    this.bancosLoading = false;
  }

  public async getMetodosDePago(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.metodosDePagoLoading = true;
    if(this.currentPresolicitud != null && this.currentPresolicitud.monRetiro != null){
      this.montoRetiro = this.currentPresolicitud.monRetiro;
    }
    const response = await this.afiliadoService.metodosDePago(
      this.montoRetiro || this.user.saldoCCI,
      term
    );

    if (response.data.entities) {
  this.metodosDePago = response.data.entities.filter(
    (x) => {
      const monto = this.montoRetiro || this.user.saldoCCI;
      return x.topeMinimo <= monto && x.topeMaximo >= monto;
    }
  );
}
else {
      this.metodosDePago = [];
    }
    this.metodosDePagoLoading = false;
  }

  public async getTiposDeCuenta(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.tiposDeCuentaLoading = true;
    const response = await this.afiliadoService.tiposDeCuenta(term);
    if (response.data.entity) {
      this.tiposDeCuenta = response.data.entity;
    } else {
      this.tiposDeCuenta = [];
    }
    this.tiposDeCuentaLoading = false;
  }
  public async getModalidadRetiroIT() {
    this.modalidadesRetiroITLoading = true;
    const response = await this.afiliadoService.getModalidadRetiroIT();
    var vava = response.data;

    if (response.data) {
      this.modalidadesRetiroIT = response.data.entity;
    } else {
      this.modalidadRetiroIT = null;
    }
    this.modalidadesRetiroITLoading = false;
    this.montoRetiro = Number(this.user.saldoCCI.toFixed(2));
  }

  public firstStepIsValid(): boolean {
    if (!this.currentPresolicitudEsModificable) {
      return true;
    }
    if (this.previousCedulaFrontalRequiereCambioDoc) {
      if (!this.inputCedulaFrontalIsValid) {
        return false;
      }
    }
    if (this.previousCedulaTraseraRequiereCambioDoc) {
      if (!this.inputCedulaTraseraIsValid) {
        return false;
      }
    }
    return (
      (this.inputsCedulaAreValid && this.cedulaIsValid) ||
      this.existPreviousCedulaFiles
    );
  }

  public secondStepIsValid(): boolean {
    if (!this.currentPresolicitudEsModificable) {
      return true;
    }
    if (this.datosCedulaCoincideConBD) {
      return true;
    }
    if (this.existPreviousDocumentoFiles) {
      if (this.previousDocumentoRequiereCambioDoc) {
        if (!this.documentoIsValid) {
          return false;
        }
      } else {
        return true;
      }
    }
    if (this.omitirActualizacionDatos) {
      return true;
    }
    return this.documentoIsValid;
  }

  public thirdStepIsValid(): boolean {
    if (!this.currentPresolicitudEsModificable) {
      return true;
    }
    if (this.previousReferenciaDocumentoBancarioRequiereCambioDoc) {
      if (!this.existReferenciaDocumentoBancarioFiles) {
        return false;
      }
    }
    return !!this.numeroSolicitudCreada;
  }

  get metodoDePagoIsTransferenciaBancaria(): boolean {
    return this.metodoDePago && this.metodoDePago.formaPago === "T";
  }

  get existReferenciaDocumentoBancarioFiles(): boolean {
    return (
      this.referenciaDocumentoBancarioFiles &&
      this.referenciaDocumentoBancarioFiles.length > 0
    );
  }

  get existPreviousCedulaFrontalFiles(): boolean {
    return !(
      this.previousCedulaFrontalFiles &&
      this.previousCedulaFrontalFiles.length === 0
    );
  }

  get existPreviousCedulaTraseraFiles(): boolean {
    return !(
      this.previousCedulaTraseraFiles &&
      this.previousCedulaTraseraFiles.length === 0
    );
  }

  get existPreviousCedulaFiles(): boolean {
    return (
      this.existPreviousCedulaFrontalFiles &&
      this.existPreviousCedulaTraseraFiles
    );
  }

  get existPreviousDocumentoFiles(): boolean {
    return !(
      this.previousDocumentoFiles && this.previousDocumentoFiles.length === 0
    );
  }

  get existPreviousReferenciaDocumentoBancarioFiles(): boolean {
    return !(
      this.previousReferenciaDocumentoBancarioFiles &&
      this.previousReferenciaDocumentoBancarioFiles.length === 0
    );
  }

  get existPreviousDocumentoAdicionalFiles(): boolean {
    return !(
      this.previousDocumentoAdicionalFiles &&
      this.previousDocumentoAdicionalFiles.length === 0
    );
  }

  get generaSolicitudAutomatica(): boolean {
    return (
      !this.metodoDePagoIsTransferenciaBancaria && this.datosCedulaCoincideConBD
    );
  }

  get valorViaNotificacionActual(): string {
    if (this.viaNotificacion) {
      switch (this.viaNotificacion.value) {
        case "E":
          return this.user.correoElectronico1 || this.user.correoElectronico2;
        case "C":
          return this.user.celular;
        default:
          return;
      }
    } else {
      return null;
    }
  }

  public nextAction(
    success: boolean,
    nextAction: (props: any, _this: RegistroIngresoTardio) => any,
    props: any
  ): void {
    if (success) {
      if (nextAction) {
        nextAction(props, this);
      }
    }
  }

  public async verificarCedula(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (!this.existPreviousCedulaFiles && !this.inputsCedulaAreValid) {
        this.callInputValidation();
        resolve(this.cedulaIsValid);
        return;
      }
      if (
        (this.previousCedulaFrontalRequiereCambioDoc &&
          !this.inputCedulaFrontalIsValid) ||
        (this.previousCedulaTraseraRequiereCambioDoc &&
          !this.inputCedulaTraseraIsValid)
      ) {
        this.callInputValidation();
        resolve(this.cedulaIsValid);
        return;
      }
      if (
        !this.existPreviousCedulaFiles ||
        this.previousCedulaFrontalRequiereCambioDoc ||
        this.previousCedulaTraseraRequiereCambioDoc
      ) {
        this.cedulaFrontalServerMessage = "";
        this.cedulaTraseraServerMessage = "";
        this.showLoadingAlert(
          "Valoramos tu tiempo. Este proceso puede tomar unos minutos. Gracias por utilizar nuestra plataforma digital de beneficios."
        );
        this.loading = true;
        this.validationService
          .validateCedulaAfiliadoIT(
            new ValidacionCedulaIt(
              this.user.cedula,
              this.user.getNombreCompleto(),
              this.user.fechaNacimientoDate,
              this.previousCedulaFrontalFiles &&
              this.previousCedulaFrontalFiles.length > 0
                ? this.previousCedulaFrontalFiles[0].ruta
                : null,
              this.previousCedulaTraseraFiles &&
              this.previousCedulaTraseraFiles.length > 0
                ? this.previousCedulaTraseraFiles[0].ruta
                : null
            ),
            {
              cedulaFrontal: this.cedulaFrontalFiles,
              cedulaTrasera: this.cedulaTraseraFiles,
            }
          )
          .then(
            (
              response: AxiosResponse<
                ServiceResponseEntity<ValidacionCedulaItResp>
              >
            ) => {
              if (response.data.respCode == 200) {
                this.datosCedulaCoincideConBD = true;
                this.resultValidacionCedula = response.data.entity;
                this.cedulaIsValid = true;
              } else {
                switch (response.data.respCode) {
                  case 410:
                    // Nombre afiliado no coincide
                    this.datosCedulaCoincideConBD = false;
                    this.resultValidacionCedula = response.data.entity;
                    if (this.resultValidacionCedula.cedulaCoincide) {
                      this.cedulaIsValid = true;
                    }
                    break;
                  case 411:
                    // Cedula frontal de baja calidad
                    this.cedulaFrontalServerMessage = response.data.message;
                    break;
                  case 412:
                    // Cedula trasera de baja calidad
                    this.cedulaTraseraServerMessage = response.data.message;
                    break;
                  default:
                    this.loading = false;
                    this.showErrorAlert(
                      "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
                      true
                    );
                    resolve(false);
                    return;
                }

                //Each time cedula validation run, update currentPresolicitud values
                if (this.currentPresolicitud) {
                  this.currentPresolicitud.cedulaCoincide = this.resultValidacionCedula.cedulaCoincide;
                  this.currentPresolicitud.nombreCoincide = this.resultValidacionCedula.nombreCoincide;
                  this.currentPresolicitud.fechaNacimientoCoincide = this.resultValidacionCedula.fechaNacimientoCoincide;
                }
              }
              this.loading = false;
              Swal.close();
              resolve(this.cedulaIsValid);
              if (!this.resultValidacionCedula.cedulaCoincide) {
                Swal.fire({
                  text:
                    "El número de cédula de identidad del documento que cargó no coincide con el número de cédula registrado en nuestra base de datos. Ambos números deben coincidir para que puedas continuar con el registro de su solicitud.",
                  icon: "warning",
                  confirmButtonText: "OK",
                });
              }
            }
          )
          .catch(() => {
            this.loading = false;
            Swal.close();
            reject();
          });
      } else {
        this.loading = false;
        Swal.close();
        resolve(true);
      }
    });
  }

  public async invalidarSolicitud(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.showLoadingConfirm(
        "Lo sentimos, actualmente no cumples con los requisitos para continuar con esta solicitud de beneficios. Esta será anulada.",
        () => {
          const registroPresolicitud = new RegistroPresolicitud();
          registroPresolicitud.presolicitud.tipoBeneficio = TipoBeneficioEnum.IngresoTardio.toString();
          registroPresolicitud.presolicitud.numeroSolicitud = this.numeroSolicitud;
          registroPresolicitud.presolicitud.cedulaAfiliado = this.user.cedula;
          registroPresolicitud.presolicitud.cedulaBeneficiario = this.user.cedula;
          registroPresolicitud.presolicitud.estado = "C";
          this.afiliadoService
            .registroPresolicitud(registroPresolicitud, {
              cedula: null,
              docsActDatos: null,
              referenciaDocumentoBancario: null,
              documentosAdicionales: null,
            })
            .then((response: AxiosResponse<ServiceResponseSolicitud>) => {
              if (response.data.respCode === 200) {
                Swal.close();
                this.$router.push("/home");
                resolve();
              } else {
                this.showErrorAlert(
                  response.data.message ||
                    "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
                  false
                );
                resolve();
              }
            })
            .catch((error) => {
              this.showErrorAlert(
                "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde.",
                false
              );
              reject();
            });
        }
      );
    });
  }

  public async completarPresolicitud(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (
        !this.isEditing ||
        (this.isEditing &&
          (this.currentPresolicitudEsModificable ||
            this.previousCedulaFrontalRequiereCambioDoc ||
            this.previousCedulaTraseraRequiereCambioDoc ||
            this.previousDocumentoRequiereCambioDoc ||
            this.documentosAdicionales.length > 0 ||
            this.previousReferenciaDocumentoBancarioRequiereCambioDoc))
      ) {
        if (!this.generaSolicitudAutomatica) {
          this.registrarPresolicitud()
            .then((response: boolean) => {
              this.loading = false;
              setTimeout(() => Swal.close(), 4000);
              resolve(response);
            })
            .catch(() => {
              reject();
            });
        } else {
          resolve(true);
        }
      } else {
        resolve(true);
      }
    });
  }

  public async registrarPresolicitud(
    showLoading: boolean = true,
    packageId?: string
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      (this.$refs.registroIngresoTardioForm as VeeValidateForm)
        .validate()
        .then(async (isValid: boolean) => {
          console.log("Validation Form Execured, result: " + isValid);
          //
          if (isValid) {
            this.clearUnusedFields();
            //
            if (
              this.metodoDePagoIsTransferenciaBancaria &&
              !this.existReferenciaDocumentoBancarioFiles &&
              !this.existPreviousReferenciaDocumentoBancarioFiles
            ) {
              console.log(
                "Metodo pago es transferencia y no referencia Doc Bancario, ni en input ni en previous"
              );
              this.showReferenciaDocumentoBancarioFilesRequiredError = true;
              resolve(!!this.numeroSolicitudCreada);
              return;
            }
            if (
              this.metodoDePagoIsTransferenciaBancaria &&
              this.previousReferenciaDocumentoBancarioRequiereCambioDoc &&
              !this.existReferenciaDocumentoBancarioFiles
            ) {
              this.showReferenciaDocumentoBancarioFilesRequiredError = true;
              resolve(!!this.numeroSolicitudCreada);
              return;
            }
            if (showLoading) {
              this.showLoadingAlert("Se están registrando los datos");
              this.loading = true;
            }
            this.showReferenciaDocumentoBancarioServerValidationMessage = false;
            this.registroPresolicitud.presolicitud.tipoBeneficio = TipoBeneficioEnum.IngresoTardio.toString();
            this.registroPresolicitud.presolicitud.numeroSolicitud = this.numeroSolicitud;
            //
            this.registroPresolicitud.presolicitud.cedulaCoincide = this.resultValidacionCedula.cedulaCoincide;
            this.registroPresolicitud.presolicitud.nombreCoincide = this.resultValidacionCedula.nombreCoincide;
            this.registroPresolicitud.presolicitud.fechaNacimientoCoincide = this.resultValidacionCedula.fechaNacimientoCoincide;

            this.registroPresolicitud.presolicitud.formaPago = this.metodoDePago.formaPago;

            if (this.metodoDePagoIsTransferenciaBancaria) {
              if (this.banco) {
                this.registroPresolicitud.presolicitud.idBanco = Number(
                  this.banco.codigoBanco
                );
              }
              if (this.tipoDeCuenta) {
                this.registroPresolicitud.presolicitud.tipoCuenta = this.tipoDeCuenta.value;
              }
              this.registroPresolicitud.presolicitud.numeroCuenta = this.numeroCuenta;
            }
            this.registroPresolicitud.presolicitud.monRetiro = this.montoRetiro;
            this.registroPresolicitud.presolicitud.tipRetiro = this.modalidadRetiroIT.codigo;
            this.registroPresolicitud.presolicitud.cedulaAfiliado = this.user.cedula;
            this.registroPresolicitud.presolicitud.cedulaBeneficiario = this.user.cedula;
            this.registroPresolicitud.presolicitud.codCuenta = this.user.codCuenta;
            if (packageId) {
              this.registroPresolicitud.presolicitud.idTransFirma = packageId;
            }
            this.registroPresolicitud.presolicitud.formaGeneraSolicitud = this
              .generaSolicitudAutomatica
              ? FormaGeneraSolicitudEnum.Automatica
              : FormaGeneraSolicitudEnum.Manual;
            if (this.viaNotificacion) {
              this.registroPresolicitud.presolicitud.viaNotificacion = this.viaNotificacion.value;
              var valorViaNotificacion =
                this.valorViaNotificacion || this.valorViaNotificacionActual;
              //
              if (this.viaNotificacion) {
                switch (this.viaNotificacion.value) {
                  case "E":
                    this.registroPresolicitud.presolicitud.eMail = valorViaNotificacion;
                    this.user.correoElectronico1 = valorViaNotificacion;
                    break;
                  case "C":
                    this.registroPresolicitud.presolicitud.numTelefono = valorViaNotificacion;
                    this.user.celular = valorViaNotificacion;
                    break;
                  default:
                    break;
                }
              }
            }
            this.registroPresolicitud.presolicitud = this.setDatosTss(
              this.registroPresolicitud.presolicitud
            );

            if (this.currentPresolicitud) {
              //Si existe el currentPresolicitud, utilizar el mismo idTransfirma para no sobreescribir
              this.registroPresolicitud.presolicitud.idTransFirma = this.currentPresolicitud.idTransFirma;
            }
            //Esto es para mover los archivos que requieren cambios a removedFiles
            this.removeFilesThatRequireChanges();
            //
            this.registroPresolicitud.archivosEliminados = this.removedFiles;
            this.registroPresolicitud.tiposDocumento = [];

            //#region Tipos de documento
            this.cedulaFiles.forEach((cedulaFile: File) => {
              this.registroPresolicitud.tiposDocumento.push(
                this.tiposDocumentoByDocumento.tipoDocumentoCedula
              );
            });
            this.documentoFiles.forEach((documentoFile: File) => {
              this.registroPresolicitud.tiposDocumento.push(
                this.tipoDocumento.codRequisito.toString()
              );
            });
            this.referenciaDocumentoBancarioFiles.forEach(
              (referenciaDocumentoBancarioFile: File) => {
                this.registroPresolicitud.tiposDocumento.push(
                  this.tiposDocumentoByDocumento
                    .tipoDocumentoReferenciaDocumentoBancario
                );
              }
            );
            this.documentoAdicionalFiles.forEach(
              (documentoAdicionalFile: Array<File>) => {
                const tiposDocumentoDocumentosAdicionales: Array<string> = this.tiposDocumentoByDocumento.tipoDocumentoDocumentosAdicionales.flat();
                this.registroPresolicitud.tiposDocumento.push(
                  ...tiposDocumentoDocumentosAdicionales
                );
              }
            );
            //#endregion
            this.afiliadoService
              .registroPresolicitud(this.registroPresolicitud, {
                cedula: this.cedulaFiles,
                docsActDatos: this.documentoFiles,
                referenciaDocumentoBancario: this
                  .referenciaDocumentoBancarioFiles,
                documentosAdicionales: this.documentoAdicionalFiles.flat(),
              })
              .then((response: AxiosResponse<ServiceResponseSolicitud>) => {
                if (response.data.respCode === 200) {
                  window.removeEventListener(
                    "beforeunload",
                    this.beforeUnloadHandler
                  );
                  this.numeroSolicitudCreada = response.data.numeroSolicitud;
                  this.numeroSolicitud = this.numeroSolicitudCreada;
                  this.setUserLoggedAction(this.user);
                } else if (response.data.respCode === 403) {
                  this.showErrorAlert(response.data.message, false);
                } else {
                  this.showErrorAlert(
                    "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde."
                  );
                }

                resolve(!!this.numeroSolicitudCreada);
              })
              .catch(() => {
                this.loading = false;
                Swal.close();
                this.showErrorAlert(
                  "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde."
                );
                reject();
              });
          } else {
            this.loading = false;
            Swal.close();
            resolve(!!this.numeroSolicitudCreada);
          }
        })
        .catch(() => {
          this.loading = false;
          Swal.close();
          reject();
        });
    });
  }

  public async navigateToSolicitudes(): Promise<boolean> {
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
    return new Promise((resolve, reject) => {
      this.$router.push("/solicitudes-beneficiario");
      resolve(true);
    });
  }

  public async firmarContratoIngresoTardio(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.registrarPresolicitud()
        .then((result: boolean) => {
          console.log(result);
          if (result) {
            const firmante: FirmanteContratoIngresoTardio = new FirmanteContratoIngresoTardio(
              this.user.correoElectronico1 || this.user.correoElectronico2,
              this.user.getNombres(),
              this.user.getApellidos(),
              this.user.celular,
              this.user.cedula,
              null,
              null,
              this.user.codCiudad,
              this.numeroSolicitudCreada,
              null,
              this.user.saldoCCI,
              this.user.fechaNacimientoDate,
              this.user.telefonoResidencia
            );
            this.afiliadoService
              .firmarContratoIngresoTardio(firmante)
              .then((response: AxiosResponse<PackageResult>) => {
                this.signUrlContrato = response.data.signingUrl;
                //  this.loading = false;
                //  Swal.close();
                resolve(true);
              })
              .catch(() => {
                this.loading = false;
                setTimeout(() => Swal.close(), 4000);
                this.showErrorAlert(
                  "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde."
                );
                reject();
              });
          } else {
            this.loading = false;
            setTimeout(() => Swal.close(), 4000);
            resolve(false);
          }
        })
        .catch(() => {
          this.loading = false;
          Swal.close();
          this.showErrorAlert(
            "Lo siento, ha ocurrido un error en la comunicación, por favor intenta más tarde."
          );
          reject();
        });
    });
  }

  public showAsesoriaAlert(): void {
    Swal.fire({
      text: "Modal with a custom image.",
      width: 800,
      showCancelButton: true,
      confirmButtonColor: "#ED8B2F",
      cancelButtonColor: "#0F6CbC",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      html:
        '<svg width="79" height="103" viewBox="0 0 79 103" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40.8132 40.4973V37.728C40.8132 36.8947 40.1379 36.2192 39.3044 36.2192C38.471 36.2192 37.7957 36.8947 37.7957 37.728V40.4973C37.7957 41.3306 38.471 42.0061 39.3044 42.0061C40.1379 42.0061 40.8132 41.3306 40.8132 40.4973Z" fill="#4CBFCE"/><path d="M56.1594 36.2192C55.326 36.2192 54.6506 36.8947 54.6506 37.728V40.4973C54.6506 41.3306 55.326 42.0061 56.1594 42.0061C56.9929 42.0061 57.6682 41.3306 57.6682 40.4973V37.728C57.6682 36.8945 56.9929 36.2192 56.1594 36.2192Z" fill="#4CBFCE"/><path d="M52.5964 46.8246C51.2956 48.1251 49.5682 48.8413 47.7319 48.8413C45.8958 48.8413 44.1683 48.1249 42.8677 46.8246C42.2785 46.2353 41.3231 46.2353 40.7341 46.8246C40.1447 47.4138 40.1447 48.369 40.7339 48.9582C42.6044 50.8287 45.0897 51.8589 47.7319 51.8589C50.374 51.8589 52.8593 50.8287 54.73 48.9582C55.3193 48.369 55.3193 47.4138 54.73 46.8246C54.1408 46.2353 53.1854 46.2353 52.5964 46.8246V46.8246Z" fill="#4CBFCE"/><path d="M46.5486 43.9086H48.9158C49.7492 43.9086 50.4246 43.233 50.4246 42.3998C50.4246 41.5665 49.7492 40.891 48.9158 40.891H48.0574V38.4546C48.0574 37.6214 47.382 36.9458 46.5486 36.9458C45.7151 36.9458 45.0398 37.6214 45.0398 38.4546V42.3998C45.0398 43.233 45.7151 43.9086 46.5486 43.9086Z" fill="#4CBFCE"/><path d="M47.7319 71.8184C48.5652 71.8184 49.2407 71.1429 49.2407 70.3096C49.2407 69.4763 48.5652 68.8008 47.7319 68.8008C46.8987 68.8008 46.2231 69.4763 46.2231 70.3096C46.2231 71.1429 46.8987 71.8184 47.7319 71.8184Z" fill="#4CBFCE"/><path d="M47.7319 78.2559C48.5652 78.2559 49.2407 77.5804 49.2407 76.7471C49.2407 75.9138 48.5652 75.2383 47.7319 75.2383C46.8987 75.2383 46.2231 75.9138 46.2231 76.7471C46.2231 77.5804 46.8987 78.2559 47.7319 78.2559Z" fill="#4CBFCE"/><path d="M54.9114 84.4918V91.7996C54.9114 92.9643 55.8589 93.9119 57.0237 93.9119H70.3147C71.4795 93.9119 72.427 92.9643 72.427 91.7996V84.4918C72.427 83.327 71.4795 82.3795 70.3147 82.3795H57.0237C55.8589 82.3795 54.9114 83.327 54.9114 84.4918ZM57.929 85.3971H69.4094V90.8943H57.929V85.3971Z" fill="#4CBFCE"/><path d="M66.0833 80.7705C66.9167 80.7705 67.592 80.095 67.592 79.2617C67.592 78.4285 66.9167 77.7529 66.0833 77.7529H61.2551C60.4217 77.7529 59.7463 78.4285 59.7463 79.2617C59.7463 80.095 60.4217 80.7705 61.2551 80.7705H66.0833Z" fill="#4CBFCE"/><path d="M76.9482 79.7646C77.7817 79.7646 78.457 79.0891 78.457 78.2559V75.4352C78.457 66.7026 71.3526 59.598 62.6198 59.598H59.3163V57.2467C59.3163 57.0423 59.2888 56.8413 59.2401 56.6466C62.0718 54.6025 64.0918 51.5016 64.7158 47.9266H66.2397C69.2655 47.9266 71.7272 45.4648 71.7272 42.4388V39.7886C71.7272 38.5089 71.2859 37.3313 70.549 36.3968V27.2761C70.549 24.5436 69.9519 21.9181 68.7748 19.4732C68.4131 18.7225 67.5111 18.4074 66.7607 18.7685C66.0099 19.13 65.6943 20.0317 66.0558 20.7825C67.0349 22.8157 67.5314 25.0004 67.5314 27.2761V34.4555C67.1168 34.3551 66.6847 34.3004 66.2397 34.3004H64.92V29.1814C64.92 27.1381 63.2577 25.476 61.2144 25.476H51.1459C49.7311 25.476 48.4583 26.2682 47.824 27.5436C46.4922 30.221 43.8098 31.8843 40.8234 31.8843H34.2495C32.6603 31.8843 31.3054 32.892 30.7801 34.3006H29.2244C28.7794 34.3006 28.3471 34.3551 27.9325 34.4557V27.2763C27.9325 19.0109 34.6571 12.2864 42.9226 12.2864H52.5413C56.0322 12.2864 59.4318 13.5135 62.1136 15.7417C62.755 16.2742 63.7057 16.1865 64.2384 15.5454C64.7709 14.9044 64.683 13.9531 64.0421 13.4206C62.6844 12.2926 61.1725 11.3811 59.5652 10.7003V9.50276C59.5654 4.26303 55.3021 0 50.0624 0H45.4017C40.1618 0 35.8989 4.26303 35.8989 9.50296V10.6955C29.4494 13.4379 24.9151 19.8376 24.9151 27.2763V36.397C24.1782 37.3313 23.7369 38.5091 23.7369 39.7886V42.4388C23.7369 45.4648 26.1986 47.9266 29.2246 47.9266H30.7485C31.4128 51.7328 33.6595 55.0014 36.7835 57.0294C36.777 57.1014 36.7712 57.1737 36.7712 57.2465V59.5978H32.8443C27.3151 59.5978 22.4425 62.4486 19.6094 66.7553C19.3256 66.715 19.0359 66.6933 18.7412 66.6933C15.4399 66.6933 12.7368 69.3021 12.5839 72.5663H11.5861C10.1994 72.5663 9.07144 73.6943 9.07144 75.081V75.3387H4.64667C3.25999 75.3387 2.13202 76.4666 2.13202 77.8533V88.1905C0.897226 88.5842 0 89.7414 0 91.1047V99.9418C0 101.628 1.37179 103 3.05822 103H75.9424C77.3291 103 78.457 101.872 78.457 100.485V85.2969C78.457 84.4636 77.7817 83.7881 76.9482 83.7881C76.1148 83.7881 75.4395 84.4636 75.4395 85.2969V99.9824H35.3501V93.5449C35.3501 92.7117 34.6748 92.0361 33.8413 92.0361C33.0079 92.0361 32.3325 92.7117 32.3325 93.5449V99.9824H11.1099V90.5668C11.1099 89.1771 9.97933 88.0465 8.58964 88.0465H5.1496V78.3564H9.08472C9.21427 79.6224 10.2865 80.6134 11.5863 80.6134H25.8963C27.1958 80.6134 28.2683 79.6224 28.3978 78.3564H32.3329V86.5039C32.3329 87.3372 33.0083 88.0127 33.8417 88.0127C34.6752 88.0127 35.3505 87.3372 35.3505 86.5039V77.8535C35.3505 76.4668 34.2226 75.3389 32.8359 75.3389H28.4111V75.0812C28.4111 73.6945 27.2831 72.5665 25.8965 72.5665H24.8984C24.8101 70.6797 23.8688 69.0134 22.4536 67.9418C24.784 64.7184 28.572 62.6153 32.8447 62.6153H36.7716V68.8489C36.7716 69.6063 37.0999 70.2961 37.6566 70.7652V73.2736C37.6566 73.851 37.8575 74.4155 38.2225 74.8627L45.7837 84.1349C46.2635 84.7229 46.9736 85.0603 47.7327 85.0603C48.4917 85.0603 49.2018 84.7229 49.6816 84.1347L57.2431 74.8627C57.6078 74.4153 57.8089 73.8508 57.8089 73.2734V71.1503C57.8295 71.1412 57.8504 71.1348 57.8707 71.1253C58.7631 70.7067 59.3171 69.8344 59.3171 68.8489V62.6153H62.6206C69.6894 62.6153 75.4403 68.3662 75.4403 75.435V78.2559C75.4395 79.0891 76.1148 79.7646 76.9482 79.7646V79.7646ZM64.92 37.3184H66.2397C67.6018 37.3184 68.7096 38.4264 68.7096 39.7886V42.4388C68.7096 43.8009 67.6016 44.909 66.2397 44.909H64.92V37.3184ZM38.9163 9.50296C38.9163 5.92693 41.8256 3.01758 45.4017 3.01758H50.0624C53.6385 3.01758 56.5478 5.92693 56.5478 9.50296V9.72405C55.2406 9.4251 53.897 9.26879 52.5415 9.26879H42.9228C41.5462 9.26879 40.2054 9.4247 38.9165 9.71861V9.50296H38.9163ZM30.5441 44.909H29.2244C27.8623 44.909 26.7543 43.8009 26.7543 42.4388V39.7886C26.7543 38.4264 27.8625 37.3184 29.2244 37.3184H30.5441V44.909ZM8.09234 91.0641V99.9824H3.05822C3.03589 99.9824 3.01758 99.9641 3.01758 99.9418V91.1047C3.01758 91.0824 3.03589 91.0641 3.05822 91.0641H8.09234ZM18.741 69.7111C20.3777 69.7111 21.7252 70.9676 21.873 72.5665H15.6087C15.7566 70.9676 17.104 69.7111 18.741 69.7111V69.7111ZM25.3931 75.5841V77.5958H12.089V75.5841H25.3931ZM54.7904 73.0946L47.7319 81.7498L40.6735 73.0946V70.9445C40.7484 70.8946 40.822 70.8417 40.8924 70.7831L46.1919 66.3803C46.6244 66.7168 47.1597 66.9067 47.7316 66.9067H47.7319C48.4428 66.9067 49.0966 66.6126 49.5661 66.1069L54.7904 70.4472V73.0946ZM39.7888 67.777V58.4915C40.3547 58.6851 40.9361 58.8442 41.5323 58.9627L44.4861 63.8743L39.7888 67.777ZM45.2112 59.225H50.2525L47.7319 63.4164L45.2112 59.225ZM56.2988 67.7772L51.1856 63.5291L53.9318 58.9627C54.7495 58.8003 55.5401 58.5629 56.2988 58.2612V67.7772ZM51.2709 56.2074H44.193C38.3307 56.2074 33.5615 51.438 33.5615 45.5759V35.5899C33.5615 35.2107 33.8701 34.9021 34.2493 34.9021H40.8234C44.9627 34.9021 48.6804 32.5975 50.5257 28.8877C50.6466 28.6447 50.884 28.4938 51.1457 28.4938H61.2142C61.5936 28.4938 61.9022 28.8024 61.9022 29.1816V45.5759C61.9024 51.438 57.1332 56.2074 51.2709 56.2074Z" fill="#4CBFCE"/></svg>' +
        '<p style="margin-top:20px">¡Excelente! Aplicas para la Devolución de Fondos por Ingreso Tardío. ¿Te gustaría que nuestro asesor financiero te contacte, para brindarte más información de cómo estarías impactando tu inversión al realizar el retiro de tus fondos?</p>',
    }).then((result) => {
      if (result.isConfirmed) {
        this.afiliadoService.registrarAsesoria(this.user.cedula);
        Swal.fire({
          width: 800,
          allowOutsideClick: false,
          html:
            '<svg width="79" height="103" viewBox="0 0 79 103" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40.8132 40.4973V37.728C40.8132 36.8947 40.1379 36.2192 39.3044 36.2192C38.471 36.2192 37.7957 36.8947 37.7957 37.728V40.4973C37.7957 41.3306 38.471 42.0061 39.3044 42.0061C40.1379 42.0061 40.8132 41.3306 40.8132 40.4973Z" fill="#4CBFCE"/><path d="M56.1594 36.2192C55.326 36.2192 54.6506 36.8947 54.6506 37.728V40.4973C54.6506 41.3306 55.326 42.0061 56.1594 42.0061C56.9929 42.0061 57.6682 41.3306 57.6682 40.4973V37.728C57.6682 36.8945 56.9929 36.2192 56.1594 36.2192Z" fill="#4CBFCE"/><path d="M52.5964 46.8246C51.2956 48.1251 49.5682 48.8413 47.7319 48.8413C45.8958 48.8413 44.1683 48.1249 42.8677 46.8246C42.2785 46.2353 41.3231 46.2353 40.7341 46.8246C40.1447 47.4138 40.1447 48.369 40.7339 48.9582C42.6044 50.8287 45.0897 51.8589 47.7319 51.8589C50.374 51.8589 52.8593 50.8287 54.73 48.9582C55.3193 48.369 55.3193 47.4138 54.73 46.8246C54.1408 46.2353 53.1854 46.2353 52.5964 46.8246V46.8246Z" fill="#4CBFCE"/><path d="M46.5486 43.9086H48.9158C49.7492 43.9086 50.4246 43.233 50.4246 42.3998C50.4246 41.5665 49.7492 40.891 48.9158 40.891H48.0574V38.4546C48.0574 37.6214 47.382 36.9458 46.5486 36.9458C45.7151 36.9458 45.0398 37.6214 45.0398 38.4546V42.3998C45.0398 43.233 45.7151 43.9086 46.5486 43.9086Z" fill="#4CBFCE"/><path d="M47.7319 71.8184C48.5652 71.8184 49.2407 71.1429 49.2407 70.3096C49.2407 69.4763 48.5652 68.8008 47.7319 68.8008C46.8987 68.8008 46.2231 69.4763 46.2231 70.3096C46.2231 71.1429 46.8987 71.8184 47.7319 71.8184Z" fill="#4CBFCE"/><path d="M47.7319 78.2559C48.5652 78.2559 49.2407 77.5804 49.2407 76.7471C49.2407 75.9138 48.5652 75.2383 47.7319 75.2383C46.8987 75.2383 46.2231 75.9138 46.2231 76.7471C46.2231 77.5804 46.8987 78.2559 47.7319 78.2559Z" fill="#4CBFCE"/><path d="M54.9114 84.4918V91.7996C54.9114 92.9643 55.8589 93.9119 57.0237 93.9119H70.3147C71.4795 93.9119 72.427 92.9643 72.427 91.7996V84.4918C72.427 83.327 71.4795 82.3795 70.3147 82.3795H57.0237C55.8589 82.3795 54.9114 83.327 54.9114 84.4918ZM57.929 85.3971H69.4094V90.8943H57.929V85.3971Z" fill="#4CBFCE"/><path d="M66.0833 80.7705C66.9167 80.7705 67.592 80.095 67.592 79.2617C67.592 78.4285 66.9167 77.7529 66.0833 77.7529H61.2551C60.4217 77.7529 59.7463 78.4285 59.7463 79.2617C59.7463 80.095 60.4217 80.7705 61.2551 80.7705H66.0833Z" fill="#4CBFCE"/><path d="M76.9482 79.7646C77.7817 79.7646 78.457 79.0891 78.457 78.2559V75.4352C78.457 66.7026 71.3526 59.598 62.6198 59.598H59.3163V57.2467C59.3163 57.0423 59.2888 56.8413 59.2401 56.6466C62.0718 54.6025 64.0918 51.5016 64.7158 47.9266H66.2397C69.2655 47.9266 71.7272 45.4648 71.7272 42.4388V39.7886C71.7272 38.5089 71.2859 37.3313 70.549 36.3968V27.2761C70.549 24.5436 69.9519 21.9181 68.7748 19.4732C68.4131 18.7225 67.5111 18.4074 66.7607 18.7685C66.0099 19.13 65.6943 20.0317 66.0558 20.7825C67.0349 22.8157 67.5314 25.0004 67.5314 27.2761V34.4555C67.1168 34.3551 66.6847 34.3004 66.2397 34.3004H64.92V29.1814C64.92 27.1381 63.2577 25.476 61.2144 25.476H51.1459C49.7311 25.476 48.4583 26.2682 47.824 27.5436C46.4922 30.221 43.8098 31.8843 40.8234 31.8843H34.2495C32.6603 31.8843 31.3054 32.892 30.7801 34.3006H29.2244C28.7794 34.3006 28.3471 34.3551 27.9325 34.4557V27.2763C27.9325 19.0109 34.6571 12.2864 42.9226 12.2864H52.5413C56.0322 12.2864 59.4318 13.5135 62.1136 15.7417C62.755 16.2742 63.7057 16.1865 64.2384 15.5454C64.7709 14.9044 64.683 13.9531 64.0421 13.4206C62.6844 12.2926 61.1725 11.3811 59.5652 10.7003V9.50276C59.5654 4.26303 55.3021 0 50.0624 0H45.4017C40.1618 0 35.8989 4.26303 35.8989 9.50296V10.6955C29.4494 13.4379 24.9151 19.8376 24.9151 27.2763V36.397C24.1782 37.3313 23.7369 38.5091 23.7369 39.7886V42.4388C23.7369 45.4648 26.1986 47.9266 29.2246 47.9266H30.7485C31.4128 51.7328 33.6595 55.0014 36.7835 57.0294C36.777 57.1014 36.7712 57.1737 36.7712 57.2465V59.5978H32.8443C27.3151 59.5978 22.4425 62.4486 19.6094 66.7553C19.3256 66.715 19.0359 66.6933 18.7412 66.6933C15.4399 66.6933 12.7368 69.3021 12.5839 72.5663H11.5861C10.1994 72.5663 9.07144 73.6943 9.07144 75.081V75.3387H4.64667C3.25999 75.3387 2.13202 76.4666 2.13202 77.8533V88.1905C0.897226 88.5842 0 89.7414 0 91.1047V99.9418C0 101.628 1.37179 103 3.05822 103H75.9424C77.3291 103 78.457 101.872 78.457 100.485V85.2969C78.457 84.4636 77.7817 83.7881 76.9482 83.7881C76.1148 83.7881 75.4395 84.4636 75.4395 85.2969V99.9824H35.3501V93.5449C35.3501 92.7117 34.6748 92.0361 33.8413 92.0361C33.0079 92.0361 32.3325 92.7117 32.3325 93.5449V99.9824H11.1099V90.5668C11.1099 89.1771 9.97933 88.0465 8.58964 88.0465H5.1496V78.3564H9.08472C9.21427 79.6224 10.2865 80.6134 11.5863 80.6134H25.8963C27.1958 80.6134 28.2683 79.6224 28.3978 78.3564H32.3329V86.5039C32.3329 87.3372 33.0083 88.0127 33.8417 88.0127C34.6752 88.0127 35.3505 87.3372 35.3505 86.5039V77.8535C35.3505 76.4668 34.2226 75.3389 32.8359 75.3389H28.4111V75.0812C28.4111 73.6945 27.2831 72.5665 25.8965 72.5665H24.8984C24.8101 70.6797 23.8688 69.0134 22.4536 67.9418C24.784 64.7184 28.572 62.6153 32.8447 62.6153H36.7716V68.8489C36.7716 69.6063 37.0999 70.2961 37.6566 70.7652V73.2736C37.6566 73.851 37.8575 74.4155 38.2225 74.8627L45.7837 84.1349C46.2635 84.7229 46.9736 85.0603 47.7327 85.0603C48.4917 85.0603 49.2018 84.7229 49.6816 84.1347L57.2431 74.8627C57.6078 74.4153 57.8089 73.8508 57.8089 73.2734V71.1503C57.8295 71.1412 57.8504 71.1348 57.8707 71.1253C58.7631 70.7067 59.3171 69.8344 59.3171 68.8489V62.6153H62.6206C69.6894 62.6153 75.4403 68.3662 75.4403 75.435V78.2559C75.4395 79.0891 76.1148 79.7646 76.9482 79.7646V79.7646ZM64.92 37.3184H66.2397C67.6018 37.3184 68.7096 38.4264 68.7096 39.7886V42.4388C68.7096 43.8009 67.6016 44.909 66.2397 44.909H64.92V37.3184ZM38.9163 9.50296C38.9163 5.92693 41.8256 3.01758 45.4017 3.01758H50.0624C53.6385 3.01758 56.5478 5.92693 56.5478 9.50296V9.72405C55.2406 9.4251 53.897 9.26879 52.5415 9.26879H42.9228C41.5462 9.26879 40.2054 9.4247 38.9165 9.71861V9.50296H38.9163ZM30.5441 44.909H29.2244C27.8623 44.909 26.7543 43.8009 26.7543 42.4388V39.7886C26.7543 38.4264 27.8625 37.3184 29.2244 37.3184H30.5441V44.909ZM8.09234 91.0641V99.9824H3.05822C3.03589 99.9824 3.01758 99.9641 3.01758 99.9418V91.1047C3.01758 91.0824 3.03589 91.0641 3.05822 91.0641H8.09234ZM18.741 69.7111C20.3777 69.7111 21.7252 70.9676 21.873 72.5665H15.6087C15.7566 70.9676 17.104 69.7111 18.741 69.7111V69.7111ZM25.3931 75.5841V77.5958H12.089V75.5841H25.3931ZM54.7904 73.0946L47.7319 81.7498L40.6735 73.0946V70.9445C40.7484 70.8946 40.822 70.8417 40.8924 70.7831L46.1919 66.3803C46.6244 66.7168 47.1597 66.9067 47.7316 66.9067H47.7319C48.4428 66.9067 49.0966 66.6126 49.5661 66.1069L54.7904 70.4472V73.0946ZM39.7888 67.777V58.4915C40.3547 58.6851 40.9361 58.8442 41.5323 58.9627L44.4861 63.8743L39.7888 67.777ZM45.2112 59.225H50.2525L47.7319 63.4164L45.2112 59.225ZM56.2988 67.7772L51.1856 63.5291L53.9318 58.9627C54.7495 58.8003 55.5401 58.5629 56.2988 58.2612V67.7772ZM51.2709 56.2074H44.193C38.3307 56.2074 33.5615 51.438 33.5615 45.5759V35.5899C33.5615 35.2107 33.8701 34.9021 34.2493 34.9021H40.8234C44.9627 34.9021 48.6804 32.5975 50.5257 28.8877C50.6466 28.6447 50.884 28.4938 51.1457 28.4938H61.2142C61.5936 28.4938 61.9022 28.8024 61.9022 29.1816V45.5759C61.9024 51.438 57.1332 56.2074 51.2709 56.2074Z" fill="#4CBFCE"/></svg>' +
            '<p style="margin-top:20px">Nuestro consultor financiero te estará contactando vía telefónica en (1) un día laboral. Es un placer servirte.</p>',
        }).then((result) => {
          this.$router.push("/solicitudes-beneficiario");
        });
      }
    });
  }

  public numberFormat(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  @Watch("modalidadRetiroIT")
  onMontoRetiroChange(value: ModalidadRetiroIT, oldValue: ModalidadRetiroIT) {
    this.montoRetiro = Number(this.user.saldoCCI.toFixed(2));
  }

  public removeParcial() {
    var minimoPension = this.modalidadesRetiroIT[0].montoMinimo;
    if (this.user.saldoCCI < minimoPension) {
      this.modalidadesRetiroIT = this.modalidadesRetiroIT.filter(
        (x) => x.codigo == "T"
      );
    }
  }
}
